import React from "react";

// Stil dosyamızı import edelim
import "./SectionTitle.scss";

// Görseli import edelim
import titleIcon from "../../assets/images/green-dog.png";
import { FaPaw } from "react-icons/fa";

// Bu component dışarıdan 'smallTitle' ve 'mainTitle' adında iki prop alacak
const SectionTitle = ({ smallTitle, mainTitle }) => {
  return (
    <div className="section-title-container">
      <div className="subtitle-wrapper">
        <FaPaw />
        <span className="small-title">{smallTitle}</span>
      </div>
      <h2 className="main-title">{mainTitle}</h2>
    </div>
  );
};

export default SectionTitle;
